export type ScrollVisibility = {
	left: boolean;
	right: boolean;
};

export const checkScrollVisibility = (scroller: HTMLElement, child: HTMLElement): ScrollVisibility => {
	const left = scroller.scrollLeft <= child.offsetLeft;
	const right = child.offsetLeft + child.offsetWidth <= scroller.scrollLeft + scroller.offsetWidth;
	return { left, right };
};
